import { ValidationProvider, useTranslation, useProperty } from '@eti/providers';
import type { ComponentType } from 'react';
import validationRules from '../utils/validationRules';

export const withPostBookingValidationProvider =
  (WrappedComponent: ComponentType) => (props: any) => {
    const { t } = useTranslation();
    const { p } = useProperty();
    const taxIdData = {
      taxIdFieldLabel: p('Payment.TaxIdFeature.Label'),
      taxIdFieldFormat: p('Payment.TaxIdFeature.Format'),
      taxIdRequired: t('ValidationMessages.TaxIdIsRequired'),
      invalidTaxId: t('ValidationMessages.TaxIdIsInvalid'),
    };

    return (
      <ValidationProvider rules={validationRules(taxIdData)}>
        <WrappedComponent {...props} />
      </ValidationProvider>
    );
  };
